// Shared color palette for touchpoint types
// Colors are chosen to be harmonious while maintaining good contrast with light backgrounds

export const touchpointColorPalette = {
  'ED visit': '#1f77b4',                    // Blue
  'EMS interaction': '#ff7f0e',             // Orange
  'Jail booking': '#2ca02c',                // Green
  'Release from prison': '#d62728',          // Red
  'Rx dispensation': '#9467bd',             // Purple
  'Rx dispensation for Buprenorphine': '#8c564b' // Brown
};

// Create a color scale function that can be used with d3
export const getTouchpointColorScale = (touchpointTypes) => {
  return (type) => touchpointColorPalette[type] || '#808080'; // Default to gray if type not found
};

